// Shared user-facing copy for media authenticity VALIDATION (we validate a
// creator's media before registering it on Vastavik). Kept in one place so the
// wording stays consistent across the panel.

export const VALIDATION_FAILED_TITLE = "The media failed validation";

export const VALIDATION_FAILED_REASONS = [
  "It may be a shared media (e.g.: via WhatsApp)",
  "It may be downloaded or copied from internet",
  "It may be enhanced or edited via AI (e.g. ChatGPT, Gemini etc.)",
  "You may have used an unfamiliar editing software which is not listed in our platform",
];

export const VALIDATION_FAILED_HELP =
  "To successfully validate the media, upload the original either transferring it via bluetooth, AirDrop, QuickShare, USB cable or upload from the same device the media was captured.";

// Shown when a media fails validation and can be recovered by matching against
// the untouched original (edited / AI-enhanced / missing-metadata cases).
export const VALIDATION_FAILED_RECOVERY_MESSAGE =
  "The media you uploaded may be AI-enhanced or AI-edited. Go to media details and upload the original to match against this media and validate it.";

// Shown on the upload page.
export const UPLOAD_VALIDATION_GUIDANCE =
  "To successfully validate a media make sure that it’s not shared media (e.g. WhatsApp), downloaded or copied from the internet. Or If you have edited the media we may ask you for the original for validation.";

export const SUPPORT_EMAIL = "support@vastavik.org";
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}?subject=Media%20validation%20review`;
